import { render, staticRenderFns } from "./flowType.vue?vue&type=template&id=a8a89138&"
import script from "./flowType.vue?vue&type=script&lang=ts&"
export * from "./flowType.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports